jQuery(document).ready(function ($) {
    "use strict";


    if ( $( '[data-mobile-sidebar]' ).length ) {

        $( '[data-mobile-sidebar]' ).on( 'click', function(e) {

            e.preventDefault();
            $( '.mobile-sidebar__filters' ).toggleClass( 'is-active' );
            $( '.mobile-sidebar__overlay' ).toggleClass( 'is-active' );

        });
    }


    $( '[data-sidebar-close]' ).on( 'click', function(e) {

        e.preventDefault();
        $( '.mobile-sidebar__filters' ).removeClass( 'is-active' );
        $( '.mobile-sidebar__overlay' ).removeClass( 'is-active' );

    });

});
